import React from "react";
import clsx from "clsx";

export function Textarea({ className = "", ...props }) {
    return (
        <textarea
            className={clsx(
                "w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-3 py-2 text-sm",
                "focus:outline-none focus:ring-2 focus:ring-violet-500",
                className
            )}
            {...props}
        />
    );
}
